/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import CustomerSupportNavBar from '../../../../layouts/customer-support/CustomerSupportNavBar';
import ActivePerCountryBody from '../../../shared/customers/ActivePerCountryBody';

const CustomerSupportActiveCustomersPerCountry = () => {
  const { profile, user } = useUser();
  const { firstName } = profile;
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <CustomerSupportNavBar currentPage="Active Customers Per Country" roleID={user.role_id} position={firstName} />
        <ActivePerCountryBody profile={profile} />
      </main>
    </div>
  );
};

export default CustomerSupportActiveCustomersPerCountry;
